import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicantEmploymentPrivatePensionSource implements Deserializable {
  public EmploymentNumber?: number;
  public PrivatePensionSourceID: number;
  public ProviderName: string;
  public IncomeAmount?: number;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
